export const DRAG_AND_DROP_EXERCISE = 'DragAndDropExercise';
export const EXPORTED_EXERCISES = [DRAG_AND_DROP_EXERCISE];